import React, { FC } from 'react';
import classNames from 'classnames';
import { PortalDialog } from '@component/Portal';

interface AlertShipDateDialogProps {
    isOpen: boolean;
    hide: () => void;
}

export const AlertShipDateDialog: FC<AlertShipDateDialogProps> = ({
    isOpen,
    hide,
}) => {
    if (isOpen === false) {
        return null;
    }

    return (
        <PortalDialog className={classNames('alert-shipdate-dialog')}>
            <div className="alert-shipdate-dialog__content">
                <h1>お知らせ</h1>
                <p>
                    選択するパーツによって発送日が変動します。ご注文の際は必ず発送日をご確認ください。
                </p>
                <button type="button" onClick={hide}>次へ →</button>
            </div>
        </PortalDialog>
    );
};
